import React from 'react'

import { Col, Form } from '_zari/core'

import { SelectCentroCostoNivel2 } from 'sharedComponents/select'

const CentroCostoNivel2FormGroup = ({ value, setValue, valueNivel1, limpiarTabla }) => {
  return (
    <Form.Group>
      <Form.Label text='Centro Costo 2' htmlFor='centrocostonivel2' md={4} />
      <Col md={8}>
        <SelectCentroCostoNivel2
          id={`select-det-centroCostoNivel2`}
          name={`select-det-centroCostoNivel2`}
          value={value}
          onChange={e => {
            setValue(e.target.value)
            limpiarTabla()
          }}
          idNodoPadre={valueNivel1}
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(CentroCostoNivel2FormGroup)
